import { IUserAutocompleteOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-option.model';
import { UserAutoCompleteCallOptionType } from '@nimbus-library/features/shared/services/user-search/models/user-auto-complete-value-type';

export function noAutocompleteRecords(text: string): IUserAutocompleteOption[] {
  return [
    {
      id: 'no_records',
      name: null,
      disabled: true,
      hasCallOptions: true,
      callOptions: [
        {
          text,
          type: UserAutoCompleteCallOptionType.not_found,
          isDisabled: true,
          icon: null,
          userId: text,
        },
      ],
    },
  ];
}
